import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { RBAC_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { UserCreatePage } from '@/features/users/pages/UserCreatePage';
import type { UserTypeGroup } from '@/features/users/constants/user.constants';

export const Route = createFileRoute('/_auth/users/create/$category')({
  beforeLoad: () => requirePermission(RBAC_PERMISSIONS.USER_CREATE),
  component: function CreateUserRoute() {
    const { category } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Create User">
        <Suspense fallback={<PageLoader />}>
          <UserCreatePage category={category as UserTypeGroup} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
